import { NeatGradient } from '@firecms/neat';
import { neatPresets } from './neat-presets.js';

let activeGradient = null;
let onScroll = null;

function teardown() {
    if (onScroll) {
        window.removeEventListener('scroll', onScroll, { passive: true });
        onScroll = null;
    }
    activeGradient?.destroy();
    activeGradient = null;
}

function presetForName(name) {
    return neatPresets[name] ?? neatPresets['dark-mode'];
}

export function initLandingGradient(canvas) {
    if (!canvas) return;

    teardown();

    const presetName = canvas.dataset.neatPreset ?? 'dark-mode';
    const preset = presetForName(presetName);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const scrollSync = canvas.dataset.neatScroll !== 'false';

    const licenseKey = import.meta.env.VITE_NEAT_LICENSE_KEY;

    activeGradient = new NeatGradient({
        ref: canvas,
        ...preset,
        speed: reducedMotion ? 0 : preset.speed,
        yOffset: 0,
        cameraLock: true,
        ...(licenseKey ? { licenseKey } : {}),
    });

    document
        .querySelector('meta[name="generator"][content*="NEAT"]')
        ?.remove();

    if (scrollSync) {
        onScroll = () => {
            if (activeGradient) {
                activeGradient.yOffset = window.scrollY;
            }
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
    }
}

export function initLandingGradients() {
    const canvas = document.querySelector('[data-neat-gradient]');
    if (!canvas) return;

    initLandingGradient(canvas);

    if (import.meta.hot) {
        import.meta.hot.dispose(teardown);
    }
}
